import moment, { Moment } from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { Organization } from './organization';
import { User } from './user';

export class ActivityLog
{
    id: number;
    logName: string;
    description: string;
    subjectType: string;
    event: string;
    organizationId: number;
    subjectId: number;
    causerType: string;
    causerId: number;
    properties: any;
    batchUuid: string;

    createdAt: Moment;
    organization: Organization;
    user: User;

    constructor(activity: any) {
        this.id = activity.id;
        this.id = activity.id;
        this.logName = activity.logName;
        this.description = activity.description;
        this.subjectType = activity.subjectType;
        this.event = activity.event;
        this.organizationId = activity.organizationId;
        this.subjectId = activity.subjectId;
        this.causerType = activity.causerType;
        this.causerId = activity.causerId;
        this.properties = activity.properties;
        this.batchUuid = activity.batchUuid;

        if (activity.organization) {
            this.organization = new Organization(activity.organization);
        }

        if (activity.causer && activity.causerType.indexOf('User') !== -1) {
            this.user = new User(activity.causer);
        }

        const timezone = LegFiJwtService.getTimezone();
        if (activity.createdAt) {
            this.createdAt = moment.utc(activity.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
    }
}
